function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Action } from "../../internal/Action.js";
import { BlendModeQualifier } from "../../qualifiers/blendMode/BlendModeQualifier.js";
import { FlagQualifier } from "../../qualifiers/flag/FlagQualifier.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { createSourceFromModel } from "../../internal/models/createSourceFromModel.js";
import { createPositionFromModel } from "../../internal/models/createPositionFromModel.js";
import { createTimelinePositionFromModel } from "../../internal/models/createTimelinePositionFromModel.js";
import { ACTION_TYPE_TO_BLEND_MODE_MAP } from "../../internal/internalConstants.js";
/**
 * @extends SDK.Action
 * @memberOf SDK
 * @description
 * A generic Layer action that can add a Video, Text or Image layer.<br>
 * This class can represent an overlay or an underlay.
 */

var LayerAction = /*#__PURE__*/function (_Action) {
  _inherits(LayerAction, _Action);

  var _super = _createSuper(LayerAction);

  /**
   * @description Creates a LayerAction to be used with overlays and underlays
   * @param {ImageSource | TextSource | VideoSource} layerSource The Source used for the layer, use the builders provided {@link Qualifiers.Source|here}
   */
  function LayerAction(layerSource) {
    var _this;

    _classCallCheck(this, LayerAction);

    _this = _super.call(this);
    _this.source = layerSource;
    _this._actionModel = {
      actionType: 'overlay',
      source: layerSource.toJson()
    };
    return _this;
  }
  /**
   * @description Sets the layerType to 'u' (underlay) or 'l' (overlay).
   * @param {'u' | 'l'} type
   * @return {this}
   */


  _createClass(LayerAction, [{
    key: "setLayerType",
    value: function setLayerType(type) {
      this.layerType = type;
      this._actionModel.actionType = type === 'u' ? 'underlay' : 'overlay';
      return this;
    }
    /**
     * @description Sets the timeline position of the video layer
     * @param {Qualifiers.TimelinePosition} timelinePosition
     * @return {this}
     */

  }, {
    key: "timeline",
    value: function timeline(timelinePosition) {
      this._timelinePosition = timelinePosition;
      this._actionModel.timelinePosition = timelinePosition.toJson();
      return this;
    }
    /**
     * @description Sets the position of the layer
     * @param {Qualifiers.Position} position
     * @return {this}
     */

  }, {
    key: "position",
    value: function position(_position) {
      this._position = _position;
      this._actionModel.position = _position.toJson();
      return this;
    }
    /**
     * @description Specifies how to blend the image overlay with the base overlay
     * @param {Qualifiers.BlendMode|BlendModeType} blendMode
     * @return {this}
     */

  }, {
    key: "blendMode",
    value: function blendMode(_blendMode) {
      this._blendMode = _blendMode;

      var _$replace$split = "".concat(_blendMode).replace('e_', '').split(":"),
          _$replace$split2 = _slicedToArray(_$replace$split, 2),
          mode = _$replace$split2[0],
          level = _$replace$split2[1];

      if (mode === 'anti_removal') {
        this._actionModel.blendMode = level ? {
          blendModeType: 'antiRemoval',
          level: level
        } : {
          blendModeType: 'antiRemoval'
        };
      } else {
        this._actionModel.blendMode = {
          blendModeType: mode
        };
      }

      return this;
    }
    /**
     * @private
     * @description
     * Closes a layer (layers are built in three stages -> /Open/Transform/Close).
     * @return {SDK.Action}
     */

  }, {
    key: "closeLayer",
    value: function closeLayer() {
      var _a, _b, _c, _d;

      var bit = new Action().addFlag(new FlagQualifier('layer_apply'));
      (_a = this._position) === null || _a === void 0 ? void 0 : _a.qualifiers.forEach(function (qualifier) {
        bit.addQualifier(qualifier);
      }); // Flags are stored separately from qualifiers, we need to add those as well

      (_b = this._position) === null || _b === void 0 ? void 0 : _b.flags.forEach(function (flag) {
        bit.addFlag(flag);
      });

      if (typeof this._blendMode === "string") {
        bit.addQualifier(new Qualifier('e', this._blendMode));
      } else {
        (_c = this._blendMode) === null || _c === void 0 ? void 0 : _c.qualifiers.forEach(function (qualifier) {
          bit.addQualifier(qualifier);
        });
      }

      (_d = this._timelinePosition) === null || _d === void 0 ? void 0 : _d.qualifiers.forEach(function (qualifier) {
        bit.addQualifier(qualifier);
      });
      return bit;
    }
    /**
     * @private
     * @description
     * Opens a layer (layers are built in three stages -> /Open/Transform/Close).
     * @return string
     */

  }, {
    key: "openLayer",
    value: function openLayer() {
      return "".concat(this.source.getOpenSourceString(this.layerType));
    }
    /**
     * @description
     * Serializes the Layer to a string
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      return [this.openLayer(), this.source.getTransformation() && this.source.getTransformation().toString(), this.closeLayer()].filter(function (a) {
        return a;
      }).join('/');
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel, transformationFromJson) {
      var source = actionModel.source,
          actionType = actionModel.actionType,
          position = actionModel.position,
          timelinePosition = actionModel.timelinePosition,
          blendMode = actionModel.blendMode;
      var sourceInstance = createSourceFromModel(source, transformationFromJson); // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this(sourceInstance);
      var layerType = actionType === 'overlay' ? 'l' : 'u';
      result.setLayerType(layerType);

      if (position) {
        result.position(createPositionFromModel(position));
      }

      if (timelinePosition) {
        result.timeline(createTimelinePositionFromModel(timelinePosition));
      }

      if (blendMode) {
        var blendModeType = ACTION_TYPE_TO_BLEND_MODE_MAP[blendMode.blendModeType] || blendMode.blendModeType;

        if (blendMode === null || blendMode === void 0 ? void 0 : blendMode.level) {
          result.blendMode(new BlendModeQualifier(blendModeType, blendMode.level));
        } else {
          result.blendMode(new BlendModeQualifier(blendModeType));
        }
      }

      return result;
    }
  }]);

  return LayerAction;
}(Action);

export { LayerAction };